import ReactDOM from 'react-dom/client';

import Hotjar from '@analytics-services/hot-jar';
import '@testsigma/atoms/dist/ui.css';
import '@testsigma/organism/dist/index.css';
import { attachStyle } from '@utils/injection';
import App from 'App';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';

import { Offline, __ } from '@testsigma/atoms';

import { isLocalStorageSupported, Memory } from '@utils/memory';

const appEl = document.getElementById('app') as HTMLElement;

const styleDependency = [];

if (import.meta.env.VITE_ENABLE_STROLLR == 'true') {
  styleDependency.push(
    `${import.meta.env.VITE_STROLLR_BASE_URL}/strollr-sdk.css`,
  );
  const strollrScript = document.createElement('script');
  strollrScript.src = `${import.meta.env.VITE_STROLLR_BASE_URL}/strollr-sdk.js`;
  document.body.appendChild(strollrScript);
}


styleDependency.map((link) => attachStyle(document.head, link));

const script = document.createElement('script');
script.type = 'module';
script.src = `${
  import.meta.env.VITE_BASE_AUDIT_URL
}/audit-trail/custom-elements/index.js?nocache=${Date.now()}`;
document.body.appendChild(script);

const idScript = document.createElement('script');
idScript.type = 'module';
idScript.src = `${
  import.meta.env.VITE_ID_SERVICE_URL
}custom-elements/index.js?nocache=${Date.now()}`;
document.body.appendChild(idScript);

if (import.meta.env.VITE_ENABLE_AMPLITUDE == 'true') {
  const amplitudeScript = document.createElement('script');
  amplitudeScript.type = 'text/javascript';
  amplitudeScript.integrity =
    'sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+';
  amplitudeScript.crossOrigin = 'anonymous';
  amplitudeScript.async = true;
  amplitudeScript.src =
    'https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js';

  amplitudeScript.onload = function () {
    if (!window.amplitude.runQueuedFunctions) {
      console.log('[Amplitude] Error: could not load SDK');
    }
  };
  document.body.appendChild(amplitudeScript);
}
const router = createBrowserRouter(
  createRoutesFromElements(<Route path='*' element={<App />} />),
  { basename: '/ui' },
);

// if not support localStorage, fallback to memory
export const storage = isLocalStorageSupported()
  ? window.localStorage
  : new Memory();

window.storage = storage;
window.__ = __;

ReactDOM.createRoot(appEl).render(
  // <React.StrictMode>
  <>
    {import.meta.env.VITE_ENABLE_HOTJAR == 'true' && <Hotjar />}
    <Offline />
    <RouterProvider router={router} />
  </>,
  // </React.StrictMode>
);
